$(function () {
    $('.registerform').on('submit', function (event) {
        event.preventDefault();

        let form = $(this);
        let action = 'subscribe';
        let shouldPost = true;

        hideFeedback(form);
        showSpinners(form);

        const company = form.find('[name="company"]').val();
        const place = form.find('[name="place"]').val();
        const address = form.find('[name="address"]').val();
        const zipcode = form.find('[name="zipcode"]').val();
        const customer_email = form.find('[name="customer_email"]').val();

        const deliver_monday = form.find('[name="deliver_monday"]:checked').val() ?? '';
        const deliver_tuesday = form.find('[name="deliver_tuesday"]:checked').val() ?? '';
        const deliver_wednesday = form.find('[name="deliver_wednesday"]:checked').val() ?? '';
        const deliver_thursday = form.find('[name="deliver_thursday"]:checked').val() ?? '';
        const deliver_friday = form.find('[name="deliver_friday"]:checked').val() ?? '';
        const days = form.find('[name^="deliver"]:checked');

        const username = form.find('[name="client_number"]').val();
        const password = form.find('[name="password"]').val();
        const password2 = form.find('[name="password2"]').val();

        if (!days.length > 0) {
            giveFeedback(form, 'days', 'Kies minimaal één leveringsdag.');
            shouldPost = false;
        }

        if (!company) {
            giveFeedback(form, 'company', 'Vul een bedrijfsnaam in.');
            shouldPost = false;
        }

        if (!place) {
            giveFeedback(form, 'place', 'Vul een plaats in.');
            shouldPost = false;
        }

        if (!address) {
            giveFeedback(form, 'address', 'Vul een adres in.');
            shouldPost = false;
        }

        if (!zipcode) {
            giveFeedback(form, 'zipcode', 'Vul een postcode in.');
            shouldPost = false;
        }
         
        if (!customer_email) {
            giveFeedback(form, 'customer_email', 'Vul een klant e-mailadres in.');
            shouldPost = false;
        }

        if (!username) {
            giveFeedback(form, 'client_number', 'Vul een klantnummer in.');
            shouldPost = false;
            console.log('no client_number');
        }

        if (!password) {
            giveFeedback(form, 'password', 'Vul een wachtwoord in.');
            shouldPost = false;
            console.log('no password');
        }

        if (form.find('.password2_col').length && form.find('.password2_col').css('display') !== 'none') {
            if (!password2) {
                giveFeedback(form, 'password2', 'Vul het wachtwoord opnieuw in.')
                shouldPost = false;
                console.log('no password2');
            }

            if (password2 && password !== password2) {
                giveFeedback(form, 'password2', 'Wachtwoorden komen niet overeen.');
                shouldPost = false;
                console.log('no equal password2')
            }
        }

        if (!shouldPost) {
            hideSpinners(form);
            showFeedback(form);
            console.log('no post');
            return;
        }

        hideResult(form);
        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: {
                action: action,
                username: username,
                password: password,
                password2: password2,
                deliver_monday: deliver_monday,
                deliver_tuesday: deliver_tuesday,
                deliver_wednesday: deliver_wednesday,
                deliver_thursday: deliver_thursday,
                deliver_friday: deliver_friday,
                company: company,
                place: place,
                address: address,
                zipcode: zipcode,
                customer_email: customer_email,
            },
            success: function (response) {
                hideSpinners(form);
            
                try {
                    // Check if response is an object (likely already parsed JSON)
                    if (typeof response === 'object') {
                        // Handle redirect or message
                        if (response.redirect) {
                            window.location.href = response.redirect;
                        } else if (response.message) {
                            showResult(form, response.message);
                        } else if (response.error) {
                            showResult(form, response.error);
                        } else {
                            showResult(form, 'Er is iets fout gegaan, probeer het opnieuw of neem contact op. Foutcode: A1');
                        }
                    } else {
                        // If the response is not an object, log it and show an error message
                        console.error('Invalid JSON response:', response);
                        showResult(form, 'Er is iets fout gegaan, probeer het opnieuw of neem contact op. Foutcode: A3 (leeg antwoord).');
                    }
                } catch (e) {
                    console.error('Error processing response:', e, response);
                    showResult(form, 'Er is iets fout gegaan, probeer het opnieuw of neem contact op. Foutcode: A2');
                }
            },
            error: function (error) {
                console.error(error);
                hideSpinners(form);
                showResult(form, 'Er is iets fout gegaan, probeer het opnieuw of neem contact op. Foutcode: A2');
            },
        });
    });

    $('.loginform').on('submit', function (event) {
        event.preventDefault();

        let form = $(this);
        let action = 'login';
        let shouldPost = true;

        hideFeedback(form);
        showSpinners(form);

        const username = form.find('[name="username"]').val();
        const password = form.find('[name="password"]').val();

        if (!username) {
            giveFeedback(form, 'username', 'Vul een klantnummer in.');
            shouldPost = false;
            console.log('no username');
        }

        if (!password) {
            giveFeedback(form, 'password', 'Vul een wachtwoord in.');
            shouldPost = false;
            console.log('no password');
        }

        if (!shouldPost) {
            hideSpinners(form);
            showFeedback(form);
            console.log('no post');
            return;
        }

        hideResult(form);
        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: {
                action: action,
                username: username,
                password: password,
            },
            success: function (response) {
                hideSpinners(form);
                if (response.redirect) {
                    window.location.href = response.redirect;
                } else if (response.message) {
                    showResult(form, response.message);
                } else if (response.error) {
                    showResult(form, response.error);
                } else {
                    showResult(form, 'Er is iets fout gegaan, probeer het opnieuw of neem contact op. Foutcode: A1');
                }
            },
            error: function (error) {
                console.error(error);
                hideSpinners(form);
                showResult(form, 'Er is iets fout gegaan, probeer het opnieuw of neem contact op. Foutcode: A2', error);
            },
        });
    });

    function showSpinners(form) {
        form.find('button[type="submit"] .spinner-border').fadeIn();
    }

    function hideSpinners(form) {
        form.find('.spinner-border').hide();
    }

    function giveFeedback(form, target, text) {
        form.find('.' + target + '_feedback').text(text);
    }

    function showFeedback(form) {
        form.find('.invalid-feedback:not(:empty)').fadeIn();
    }

    function hideFeedback(form) {
        form.find('.invalid-feedback').hide().text('');
    }

    function hideResult(form) {
        form.find('.loginform_result').fadeOut().text('');
    }

    function showResult(form, text) {
        form.find('.loginform_result').text(text).fadeIn();
    }
});
